import AccountsAccountsReducer, {
  AccountsAccountsState,
  Actions as AccountsAccountsActions,
  initialState as initialAccountsAccountsState,
} from 'src/app/AccountsAccounts/redux/accountsAccounts.reducer'
import AccountsBudgetsReducer, {
  AccountsBudgetsState,
  Actions as AccountsBudgetsActions,
  initialState as initialAccountsBudgetsState,
} from 'src/app/AccountsBudgets/redux/accountsBudgets.reducer'
import AccountsRequestsReducer, {
  AccountsRequestsState,
  Actions as AccountsRequestsActions,
  initialState as initialAccountsRequestsState,
} from 'src/app/AccountsRequests/redux/accountsRequests.reducer'
import AccountsVirtualCardsReducer, {
  AccountsVirtualCardsState,
  Actions as AccountsVirtualCardsActions,
  initialState as initialAccountsVirtualCardsState,
} from 'src/app/AccountsVirtualCards/redux/accountsVirtualCards.reducer'

export type AccountsState = {
  accountsVirtualCards: AccountsVirtualCardsState
  accountsRequests: AccountsRequestsState
  accountsAccounts: AccountsAccountsState
  accountsBudgets: AccountsBudgetsState
}

export const initialState: AccountsState = {
  accountsVirtualCards: initialAccountsVirtualCardsState,
  accountsRequests: initialAccountsRequestsState,
  accountsAccounts: initialAccountsAccountsState,
  accountsBudgets: initialAccountsBudgetsState,
}

export type Actions =
  | AccountsVirtualCardsActions
  | AccountsRequestsActions
  | AccountsAccountsActions
  | AccountsBudgetsActions

const AccountsReducer = (
  state = initialState,
  action: Actions,
): AccountsState => ({
  accountsVirtualCards: AccountsVirtualCardsReducer(
    state.accountsVirtualCards,
    action as AccountsVirtualCardsActions,
  ),
  accountsRequests: AccountsRequestsReducer(
    state.accountsRequests,
    action as AccountsRequestsActions,
  ),
  accountsAccounts: AccountsAccountsReducer(
    state.accountsAccounts,
    action as AccountsAccountsActions,
  ),
  accountsBudgets: AccountsBudgetsReducer(
    state.accountsBudgets,
    action as AccountsBudgetsActions,
  ),
})

export default AccountsReducer
